<template>
    <div class="ranking">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :error.sync="error" error-text="请求失败，点击重新加载" :immediate-check="false">
            <div v-for="(v, k) in jobTabs" :key="k">
                <div v-if="currentJobTab == k + 1">
                    <!-- banner -->
                    <img class="banner" :src="`${v.url}2025-08-01/${v.bannerImg}.png`" alt="banner">
                    <span :class="['rule', ` rule${currentJobTab}`]" @click="toRule"> 活动规则 </span>
                    <!-- <img class=" rule" @click="showRule = true" :src="`${v.url}2025-02-18/${v.ruleImg}.png`"> -->
                    <!-- 奖品 -->
                    <div class="reward-box">
                        <!--                        <div :class="['reward', `reward${currentJobTab}`]" :style="{ backgroundImage: `url(${v.url}20250618/${v.rewardImg}.png)` }">-->
                        <!--                        </div>-->
                        <!-- <div>
                            <img :class="['reward', `reward${currentJobTab}`]" :src="`${v.url}20250618/${compareMain()}`">
                        </div> -->
                        <div class="bear-palm">
                            <p>获奖奖品</p>
                            <div class="reward-item">
                                <p>激励对象：</p>
                                <p>{{ jobTabs[currentJobTab - 1].card1 }} </br>{{ jobTabs[currentJobTab - 1].card4 }}</p>
                            </div>
                            <div class="reward-item">
                                <p>激励机制：</p>
                                <p>{{ jobTabs[currentJobTab - 1].card2 }}</p>
                            </div>
                            <div class="reward-list">
                                <div class="left">
                                    <p v-if="currentJobTab === '2' && currentMoldTab != '第一组'">小组PK达成人数前两名</p>
                                    <p v-else>{{ jobTabs[currentJobTab - 1].card3 }}</p>
                                    <p v-if="currentJobTab == 1">
                                        {{ currentMoldTab == '第一组' ? '12000' : currentMoldTab == '第二组' ? '8000' : currentMoldTab == '第三组' ? '5000' : '3000' }}
                                        元奖金
                                    </p>
                                    <p v-else>
                                        {{ currentMoldTab == '第一组' ? '20' : currentMoldTab == '第二组' ? '8' : currentMoldTab == '第三组' ? '5' : '2' }}
                                        万元颜值基金券</p>
                                </div>
                                <div class="right">
                                    <img :src="`https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-08-01/${v.rightImg}.png`" alt="right image">
                                </div>
                            </div>
                        </div>
                        <div v-if="groupNoList[Number(currentJobTab) - 1] === currentMoldTab && !loading">
                            <!-- <div>
                                <img class="reward-status" :src="`${v.url}20250618/${compareTime(dataInfo.rnkReal,dataInfo.endDate)}`">
                            </div> -->
                            <div class="mmbMum-box" v-if="currentJobTab == 1 && myInfo">
                                <div class="flex flex-between align-center">
                                    <div class="flex-1 flex-y-center flex-x-center">
                                        <div>
                                            <div class="mmbMum-title">目标达成率</div>
                                            <div :class="[dataInfo.isReach == '1' ? 'avtive-top-38' : 'top-38']">
                                                <div class="left">{{ dataInfo.saleDc }}%</div>
                                                <div class="right">({{ dataInfo.isReach == '1' ? '已达成' : '未达成' }})</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex-1 flex-y-center flex-x-center">
                                        <div>
                                            <div class="mmbMum-title">销售额</div>
                                            <div class="avtive-top-38">
                                                <div class="saleJune">{{ dataInfo.saleAmtAll || 0 }}w</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="mmbMum">
                                    {{ dataInfo.head }}
                                </div>
                            </div>
                        </div>
                        <p class="update-time">数据更新时间{{ dataInfo.dateTime }}-0点</p>
                    </div>

                    <div :class="[currentJobTab == 1 ? 'bg-color' : 'bg-color-two']"></div>
                </div>
            </div>
            <div class="ranking-box">
                <div class="tabs-box">
                    <div class="job-tabs">
                        <!--    第一层     -->
                        <div class="between">
                            <div class="job-tab-item" v-for="(it, ind) in jobTabs" :key="ind" :class="{ on: currentJobTab == it.dictValue }" @click="onJobTab(it)">
                                {{ it.dictLabel }}
                            </div>
                        </div>
                        <!--    第二层     -->
                        <!-- <div class="top53">
                            <div class="group-tab-item" :class="{ on: currentGroupTab == j.dictValue }" v-for="(j, n) in jobTabs[currentJobTab - 1].groupTabs" :key="n" @click="onGroupTab(j)">
                                {{ j.dictLabel }}
                            </div>
                        </div> -->
                        <!--    第三层     -->
                        <div>
                            <div class="new-group-tab-item" :class="{ on: currentMoldTab == j, nextOn: currentJobTab == 2 && currentMoldTab == j }" v-for="(j, n) in jobTabs[currentJobTab - 1].moldTabs" :key="n" @click="onMoldTab(j)">
                                {{ j }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="ranking-list-box">
                    <div class="myWrapper" v-if="myInfo">
                        <RankingItem :currentJobTab="currentJobTab" isMe :list="[myInfo]" :currentGroupTab="currentGroupTab" />
                    </div>
                    <div class="ranking-list-item title">
                        <div class="ranking-num">排名</div>
                        <div class="ranking-name">{{ jobTabs[currentJobTab - 1].title1 }}</div>
                        <div class="ranking-order">{{ jobTabs[currentJobTab - 1].title2 }}</div>
                        <div class="ranking-bonus">{{ jobTabs[currentJobTab - 1].title3 }}</div>
                    </div>
                    <RankingItem :currentJobTab="currentJobTab" :list="list" :currentGroupTab="currentGroupTab" />
                </div>
            </div>
        </van-list>
    </div>
</template>

<script>
    import request from '@/utils/request'
    import RankingItem from './rankingItem.vue'
    import { debounce } from 'lodash';
    import { ActionSheet, Toast } from 'vant'

    export default {
        name: 'ssRankList',
        components: {
            RankingItem,
            [ActionSheet.name]: ActionSheet
        },
        computed: {
            rank() {
                return function (item) {
                    if (this.currentJobTab == 1) {
                        return item.rnk
                    }
                    if (this.currentJobTab == 2 && this.currentGroupTab == 1) {
                        return item.nxRnk
                    }
                    if (this.currentJobTab == 2 && this.currentGroupTab == 2) {
                        return item.saleRnk
                    }
                }
            },

            showReword() {
                // 未达标且没有我的数据
                if (this.currentJobTab == 1 && (!this.dataInfo.cspPk && this.dataInfo.head === '未达标')) {
                    return false
                } else {
                    return true
                }
            },

            //主图
            compareMain() {
                return () => {
                    const { currentJobTab, currentGroupTab, currentMoldTab } = this;
                    console.log(currentJobTab, currentGroupTab, currentMoldTab, 'currentJobTab, currentGroupTab, currentMoldTab')
                    const rewards = {
                        '1': {
                            // 超声炮销售额PK
                            '旗舰': '旗舰-奖励800.png',
                            '标准': '标准-奖励300.png',
                            '中心': '中心-奖励500.png',
                            '初创': '初创-200.png'
                        },
                        '2': {
                            // 无创消费额PK
                            '1': {
                                '第一组': '无创-6月奖励1000:800.png',
                                '第二组': '无创-6月奖励800:500.png',
                                '第三组': '无创-6月奖励500:300.png'
                            },
                            '2': {
                                '第一组': '无创-6-7月奖励.png',
                                '第二组': '无创-6-7月奖励.png',
                                '第三组': '无创6-7月-组3.png'
                            }
                        }
                    };

                    if (currentJobTab === '1') {
                        return rewards[currentJobTab][currentMoldTab] || '';
                    } else {
                        return rewards[currentJobTab]?.[currentGroupTab]?.[currentMoldTab] || '';
                    }
                };
            },

            //活动和阶段
            compareTime() {
                return function (rnkReal, endDate) {
                    if (!rnkReal && !endDate) {
                        return
                    }
                    const isTimeout = new Date().getTime() > new Date(endDate).getTime()
                    if (this.currentJobTab === '1') {
                        // 阶段超时未获奖
                        if (isTimeout && !rnkReal) {
                            return '阶段结束未获奖.png'
                        }
                        // 阶段超时获奖
                        if (isTimeout && rnkReal) {
                            return '阶段结束获奖.png'
                        }
                        // 阶段未超时未获奖
                        if (!isTimeout && !rnkReal) {
                            return '阶段未超时未获奖.png'
                        }
                        // 阶段未超时获奖
                        if (!isTimeout && rnkReal) {
                            return '阶段未超时获奖.png'
                        }
                    } else {
                        // 活动超时未获奖
                        if (isTimeout && !rnkReal) {
                            return '活动结束.png'
                        }
                        // 活动超时获奖
                        if (isTimeout && rnkReal) {
                            return '活动结束获奖.png'
                        }
                        // 活动未超时未获奖
                        if (!isTimeout && !rnkReal) {
                            return '活动进行中未获奖.png'
                        }
                        // 活动未超时获奖
                        if (!isTimeout && rnkReal) {
                            return '活动进行中获奖.png'
                        }
                    }
                }
            },
        },
        data() {
            return {
                showRule: false, // 是否显示规则弹窗
                jobTabs: [
                    {
                        dictLabel: '微整销售额激励', dictValue: '1',
                        groupTabs: [
                            { dictLabel: '6.1-6.20', dictValue: '1' },
                            { dictLabel: '6.21-6.30', dictValue: '2' },
                            { dictLabel: '7.1-7.20', dictValue: '3' },
                            { dictLabel: '7.21-8.7', dictValue: '4' },
                        ],
                        moldTabs: [],
                    },
                    {
                        dictLabel: '门诊消费大单人数激励', dictValue: '2',
                        groupTabs: [{ dictLabel: '6月无创消费PK', dictValue: '1' }, { dictLabel: '6-7月累计无创消费PK', dictValue: '2' }],
                        moldTabs: [],
                    }], // 职位分类标签列表
                currentJobTab: '1',
                groupNoList: ['', ''],
                myInfo: [],
                groupTabs: [{ dictLabel: '超声炮', dictValue: '1' }, { dictLabel: '超V脸', dictValue: '2' }], // 分组标签列表
                currentGroupTab: '1', // 当前选中的分组
                currentMoldTab: '', // 当前选中第三层分组
                loading: true, // 是否正在加载
                finished: false, // 是否加载完成
                list: [], // 排名列表数据
                isStore: 0, // 当前选中的tab
                page: 1, // 当前页码
                error: false, // 是否发生错误
                themeArr: [
                    {
                        "bgColor": "#FFE68F",
                        "url": "https://staticwecom.beautyfarm.com.cn/wecom-workbench/",
                        "bannerImg": "bannerYmTIMESO",
                        "rightImg": "xj",
                        "rewardImg": "duiduhuojiang",
                        "leftText1": "我的",
                        "leftText2": "当前小红花数量",
                        "rightText1": "第10名门店",
                        "rightText2": "当前小红花数量",
                        "card1": "全体美学顾问（含院长、专家、顾问）；",
                        "card2": "个人TIMESO销售目标100%达成，取微整销售金额前三名瓜分奖，多干多拿",
                        "card3": "小组PK前3名",
                        "card4": "实际分组按门诊上报目标岗位为准",
                        "cardUrl": "当前小红花数量",
                        "updateTime": "数据更新时间",
                        "title1": "姓名",
                        "title2": "销售额",
                        "title3": "奖金",
                        jobtab: '',
                    },
                    {
                        "bgColor": "#8B020F",
                        "url": "https://staticwecom.beautyfarm.com.cn/wecom-workbench/",
                        "bannerImg": "bannerYmMz",
                        "rightImg": "jzq",
                        "rewardImg": "naxinxiaoshouhuojiang",
                        "leftText1": "我的门店",
                        "leftText2": "当前问卷平均分",
                        "rightText1": "",
                        "rightText2": "当前问卷平均分",
                        "card1": "门诊整体",
                        "card2": "同类型门诊PK活动期间内8W及以上消费大单人数",
                        "card3": "小组PK达成人数第一名",
                        "card4": "",
                        "updateTime": "数据更新时间",
                        "title1": "姓名",
                        "title2": "大单人数",
                        "title3": "颜值基金券",
                        jobtab: '',
                    }
                ],
                dataInfo: {}
            }
        },
        mounted() {
            const newArr = this.jobTabs.map((item, index) => {
                return { ...item, ...this.themeArr[index] }
            })
            this.jobTabs = newArr
            this.getGroupList('1')
        },
        methods: {
            // 获取组
            getGroupList(type) {
                if (!type) return
                const params = {
                    type: type
                }
                return request({
                    url: "/motivate/groupNo",
                    method: "get",
                    params
                })
                    .then((res) => {
                        const tabIndex = type === '1' ? 0 : 1;
                        this.jobTabs[tabIndex].moldTabs = res.data.list || [];
                        this.currentMoldTab = this.jobTabs[tabIndex].moldTabs.find(itm => itm === res.data.groupNo) || '';
                        this.getDataList()
                        this.groupNoList[tabIndex] = res.data.groupNo; //存储当前用户属于哪个第三组下
                    }).catch((error) => {
                        Toast({ position: 'top', message: error ?? '' })
                    })
            },

            // 初始化数据，获取销售列表
            getDataList: debounce(async function () {
                Toast.loading({
                    forbidClick: true,
                    duration: 0
                });
                if (this.finished) return
                try {
                    const params = {
                        groupNo: this.currentMoldTab,
                        type: this.currentJobTab,
                        mold: this.currentGroupTab,
                        page: this.page
                    }
                    const { code, msg, data } = await request({
                        url: '/motivate/getList',
                        method: 'get',
                        params
                    })
                    if (code !== 0) {
                        throw new Error(msg)
                    }
                    Toast.clear();
                    // 对应jobTabs中的dataInfo赋值
                    this.dataInfo = data
                    // 对赌激励取cspPkList ，销售纳新取cspMmbList
                    const list = this.currentJobTab == 1 ? data && data.saleList : data && data.bigorderList
                    this.myInfo = this.currentJobTab == 1 ? data && data.saleData : data && data.bigorderData
                    if (this.page == 1) {
                        this.list = list
                    } else {
                        this.list = this.list.concat(list)
                    }
                    this.page += 1
                    this.loading = false;

                    if (list.length < 10) {
                        this.finished = true;
                    }
                } catch (error) {
                    this.loading = false;
                    this.error = true;
                    this.$toast(error)
                }

            }, 500),
            onLoad() {
                this.getDataList()
            },
            // 切换职位分类标签
            onJobTab(value) {
                this.currentJobTab = value.dictValue;
                this.currentGroupTab = '1'
                this.page = 1
                this.finished = false
                this.error = false;
                this.getGroupList(value.dictValue)
            },
            // 切换分组标签
            onGroupTab(v) {
                this.currentGroupTab = v.dictValue;
                this.finished = false
                this.error = false;
                this.page = 1
                this.getDataList()
                // this.getGroupList(this.currentJobTab)
            },
            // 切换第三层分组
            onMoldTab(v) {
                this.currentMoldTab = v;
                this.finished = false
                this.error = false;
                this.page = 1
                this.getDataList()
            },
            toRule() {
                this.$router.push({ path: '/newRankingRules', query: { currentJobTab: this.currentJobTab } })
            }
        }
    }
</script>

<style lang='less' scoped>
    .ranking {
        position: relative;
        height: 100%;
        font-size: 28px;
        overflow-y: scroll;
        color: #333333;
        background-color: #fff;
    }

    .mmbMum-box {
        margin: 40px 0;
        margin-bottom: 20px;

        .mmbMum-title {
            font-size: 24px;
        }

        .mmbMum {
            color: #0072FF;
            font-size: 46px;
            margin: 38px 0 40px 0;
            font-weight: bold;
        }

        .avtive-top-38 {
            margin-top: 38px;
            display: flex;
            align-items: center;
            justify-content: center;

            .left {
                font-weight: bold;
                font-size: 46px;
                color: #0072FF;
            }

            .right {
                margin-left: 20px;
                font-weight: bold;
                font-size: 30px;
                color: #0072FF;
            }

            .saleJune {
                font-weight: bold;
                font-size: 46px;
                color: #0072FF;
            }
        }

        .top-38 {
            margin-top: 38px;
            display: flex;
            align-items: center;
            justify-content: center;

            .left {
                font-weight: bold;
                font-size: 46px;
                color: #D62C18;
            }

            .right {
                margin-left: 20px;
                font-weight: bold;
                font-size: 30px;
                color: #D62C18;
            }

            .saleJune {
                font-weight: bold;
                font-size: 46px;
                color: #0072FF;
            }
        }
    }

    .myWrapper {
        padding: 20px;
    }

    .banner {
        width: 100%;
        height: 464px;
    }

    .rule {
        position: absolute;
        width: 120px;
        top: 50px;
        right: 0;
        width: 120px;
        height: 61px;
        line-height: 61px;
        font-size: 26px;
        text-align: center;
        color: #ffffff;
        background: #D22E28;
        border-top-left-radius: 31px;
        border-bottom-left-radius: 31px;
        // padding: 10px 0;
    }

    .rule1,
    .rule2 {
        background: #DBC7C1;
    }

    .rule3 {
        background: #DBC7C1;
    }

    .reward-box {
        position: relative;
        width: 100%;
        margin-top: -94px;
        padding: 30px;
        text-align: center;
        background-color: #fff;
        border-radius: 40px;
        z-index: 9;

        .reward-status {
            width: 100%;
            // margin-bottom: 30px;
        }

        .bear-palm {
            width: 100%;
            background: #F9F5F0;
            border-radius: 50px;
            text-align: initial;
            padding: 0 63px;
            font-size: 24px;
            color: #666666;
            padding-bottom: 50px;

            p {
                margin: 0;
                font-size: 24px;
            }

            .reward-item {
                display: flex;
                width: 100%;
                margin-top: 20px;

                p {
                    width: 120px;
                }

                p:nth-child(2) {
                    flex: 1;
                }
            }

            >p {
                width: 325px;
                height: 70px;
                background: linear-gradient(84deg, #DCC7C1, #D4C7C2);
                border-radius: 0px 0px 40px 40px;
                margin: 0 auto;
                text-align: center;
                font-weight: bold;
                font-size: 36px;
                color: #FFFFFF;
                line-height: 70px;
                text-shadow: 1px 3px 0px rgba(60, 0, 94, 0.52);
            }

            .reward-list {
                display: flex;
                align-items: center;
                justify-content: space-around;
                width: 100%;
                margin-top: 40px;
                color: #333333;

                >div {
                    flex: 1;
                    text-align: center;

                    img {
                        width: 150px;
                    }
                }

                .right {
                    text-align: right;
                }

                .left {
                    font-size: 30px;

                    p {
                        margin-bottom: 15px;
                        font-size: 26px;
                    }

                    p:nth-child(2) {
                        color: #D41D16;
                        font-size: 30px;
                    }
                }
            }
        }
    }

    .reward {
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 100%;
        height: 100%;
        // padding-bottom: 30px;
        // padding-top: 80px;
        margin-bottom: 30px;
        // background-image: url('https://staticwecom.beautyfarm.com.cn/wecom-workbench/20250618/bg.png');
        background-size: 100% 100%;

        // &.left {
        //     padding-right: 30px;
        //     padding-left: 20px;
        // }
        >div {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .horizantalBox {
            padding: 80px 108px 30px 108px;
        }

        .columnBox {
            align-items: flex-end;
        }

        .reward-data {
            flex-grow: 1;
            flex-shrink: 0;
            text-align: center;
            width: 50%;

            >img {
                height: 150px;
            }

            >div {
                font-size: 36px;
            }

            .fontRed {
                color: #D41D16;
                font-size: 42px;
                font-weight: bold;
            }

            &:first-of-type {
                width: 60%;
            }
        }

        .reward-data-column {

            >div {
                font-size: 36px;
                padding-top: 10px;
            }

            .fontRed {
                color: #D41D16;
                font-size: 42px;
                font-weight: bold;
            }

            img {
                height: 150px;
                vertical-align: sub;
                padding-left: 75px;
            }
        }


    }

    .reward2 {
        height: 100%;
    }

    .compare {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 30px 0;

        .less {
            width: 40px;
            height: 40px;
        }

        .compare-data {
            width: 45%;

            p {
                margin-bottom: 10px;
            }

            p:first-child {
                font-size: 36px;
            }

            p:nth-child(2) {
                font-size: 24px;
            }

            p:last-child {
                font-size: 46px;
                font-weight: 500;
            }
        }
    }

    .update-time {
        font-size: 24px;
        color: #999999;
        margin-top: 20px;
        margin-bottom: 0;
    }

    .fs-32 {
        font-size: 32px;
    }

    .blue {
        color: #007AFF;
        font-weight: 500;
    }

    .ranking-box {
        overflow: hidden;
        background-color: #fff;
        border-radius: 40px 40px 0 0;
    }

    .ranking-box-hd {
        display: flex;
        position: relative;

        >div {
            // width: 50%;
            line-height: 100px;
            // font-size: 36px;
            font-weight: 500;
            text-align: center;
            color: #999999;
            padding: 0 15px;
            // background-color: #F5F5F5;

            &.on {
                position: relative;
                color: #333333;

                &::before {
                    position: absolute;
                    content: '';
                    left: 50%;
                    bottom: 20px;
                    width: 40px;
                    height: 6px;
                    transform: translate(-50%);
                    background-color: #333333;
                    border-radius: 4px;
                }
            }
        }
    }

    .tabs-box {
        padding: 0 30px;
    }

    .between {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 55px;
    }

    .job-tabs {
        // display: flex;
        margin: 20px 0 30px 0;

        >div {
            display: flex;
        }

        .top53 {
            margin-top: 33px;
            padding: 0 21px;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
    }

    .job-tab-item {
        color: #999999;
        font-size: 30px;
        margin: 10px 0px 29px 0;
        font-weight: 500;
        text-align: center;
        border-radius: 30PX;
        position: relative;

        &.on {
            color: #333333;
            font-weight: bold;

            // background-color: #DAA55F;
            // color: #ffffff;
            &::before {
                position: absolute;
                content: '';
                left: 50%;
                bottom: -15px;
                width: 40px;
                height: 6px;
                transform: translate(-50%);
                background-color: #333333;
                border-radius: 4px;
            }
        }
    }

    .group-tabs {
        display: flex;
        align-items: center;
        margin-bottom: 30px;
    }

    .new-group-tab-item {
        width: 120px;
        height: 40px;
        margin-right: 30px;
        line-height: 40px;
        text-align: center;
        font-size: 26px;
        color: #333333;
        background-color: #E6E6E6;
        border-radius: 20px;

        &.on {
            color: #ffffff;
            font-weight: bold;
            background-color: #DBC7C1;
        }

        &.nextOn {
            color: #ffffff;
            font-weight: bold;
            background-color: #DBC7C1;
        }
    }

    .group-tab-item {
        text-align: center;
        color: #999999;
        font-size: 30px;
        border-radius: 20px;

        &.on {
            font-weight: bold;
            font-size: 30px;
            color: #333333;
        }
    }

    .group-tab-item {
        width: 120px;
        height: 40px;
        margin-right: 30px;
        line-height: 40px;
        text-align: center;
        font-size: 26px;
        color: #333333;
        background-color: #E6E6E6;
        border-radius: 20px;

        &.on {
            color: #ffffff;
            background-color: #AB080B;
        }
    }

    .ranking-list-box {
        border-top: 2px solid #eeeeee;
    }

    .ranking-list-item-box {
        padding: 0 20px;
    }

    .ranking-list-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        // margin: 10px 0;
        padding: 30px 40px;
        border-bottom: 2px solid #eeeeee;

        &.title {
            padding-bottom: 0;
            border: none;
            color: #999999;
        }
    }

    .ranking-num {
        width: 70px;
        margin-right: 40px;
        text-align: center;

        .color-red {
            color: #AB080B;
        }

        >img {
            width: 50px;
            height: 60px;
        }
    }

    .ranking-name {

        flex: 2.5;
        display: flex;
        align-items: center;
        width: 260px;

        >.img {
            width: 60px;
            height: 60px;
            margin-right: 10px;
        }

    }

    .ranking-order {
        flex: 1.2;
        text-align: center;
    }

    .ranking-bonus {
        flex: 1.8;
        text-align: center;
    }



    .popup-rule {
        width: 650px;
        padding-bottom: 30px;
        background-color: #fff;
        border-radius: 16px;
        overflow: hidden;
    }

    .popup-rule-hd {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 120px;
        font-size: 36px;
        font-weight: 500;
        background-image: linear-gradient(#CEDBF0, #ffffff);
    }

    .popup-main {
        height: 600px;
        overflow-y: scroll;

        >.title {
            padding: 20px 40px;
            font-size: 28px;
            font-weight: 500;
        }

        >.describe {
            padding: 0 60px;
            font-style: 24px;
            color: #66757F;
            line-height: 46px;
        }
    }

    .popup-close {
        position: absolute;
        left: 50%;
        bottom: -90px;
        transform: translate(-50%);
    }

    .bg-color {
        height: 90px;
        margin: -30px 0;
        background-color: #E9E9E9;
    }

    .bg-color-two {
        height: 90px;
        margin: -30px 0;
        background-color: #E9E9E9;
    }

    .cityWrapper {
        padding: 20px 0;

        .cityBox {
            display: flex;
            align-items: center;

            .position {
                width: 23px;
                height: 28px;
                margin-left: 20px;
            }

            .arrow {
                width: 10px;
                height: 18px;
            }

            >span {
                padding: 0 15px;
            }
        }
    }
</style>
<style lang="less">
    .ranking {
        .red {
            color: #D41D16;
            font-weight: 500;
        }

        .van-popup {
            overflow-y: visible;
        }

        .van-image__error {
            background-color: #A1A1A1;
        }

        .van-list__finished-text,
        .van-list__loading,
        .van-list__error-text {
            margin-top: -2px;
            background-color: #fff;
        }
    }
</style>
